import { render, staticRenderFns } from "./Richtext.vue?vue&type=template&id=0a616cf2"
import script from "./Richtext.vue?vue&type=script&lang=js"
export * from "./Richtext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports